import { createAsyncThunk } from '@reduxjs/toolkit'
import { LoanOfficersServerData, AppOfficersServerData } from '@lk/api'

import { ThunkApi } from '../index.d'
import { actions as LKModalActions } from '../../features/shared/LKModal'

export const loadOfficerList = createAsyncThunk<LoanOfficersServerData, void, ThunkApi>(
  '[LOAN_OFFICER] LOAN_OFFICER_LIST',
  async (_, { dispatch, extra, rejectWithValue }) => {
    const active = true

    const result = await extra.api.loanOfficer.getOfficerList(active)

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message))

    return rejectWithValue('Failed to load officer list')
  },
)

export const loadAppList = createAsyncThunk<AppOfficersServerData, void, ThunkApi>(
  '[LOAN_OFFICER] LOAN_APP_LIST',
  async (_, { dispatch, extra, rejectWithValue }) => {
    const active = true

    const result = await extra.api.loanOfficer.getAppList(active)

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message))

    return rejectWithValue('Failed to load app list')
  },
)

interface LoadAvailableOfficerListAttributes {
  loanId: number
  loanHash: string
}

export const loadAvailableOfficerList = createAsyncThunk<
  LoanOfficersServerData,
  LoadAvailableOfficerListAttributes,
  ThunkApi
>('[LOAN_OFFICER] LOAN_AVAILABLE_OFFICER_LIST', async ({ loanId, loanHash }, { dispatch, extra, rejectWithValue }) => {
  const result = await extra.api.loanOfficer.getAvailableList(loanId, loanHash)

  if (result.success) {
    return result.data
  }

  dispatch(LKModalActions.openError(result.error.message))

  return rejectWithValue('Failed to load available officer list')
})
